// Privacy-respecting event tracker. Works with no analytics ID configured;
// pushes to window.dataLayer so GA4/GTM can be connected later without code changes.
// Never pass personal form data into events.

export const track = (event, params = {}) => {
  const payload = { event, ...params, ts: Date.now() };
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
  if (typeof window.gtag === "function") {
    window.gtag("event", event, params);
  }
};

export const EVENTS = {
  requestQuoteClick: "request_quote_click",
  whatsappClick: "whatsapp_click",
  phoneClick: "phone_click",
  emailClick: "email_click",
  productQuoteClick: "product_quote_click",
  sampleRequestClick: "sample_request_click",
  formStart: "form_start",
  formSubmitSuccess: "form_submit_success",
  formSubmitError: "form_submit_error",
};
